import {AxiosResponse} from 'axios'

import {DealersContact} from '@/types/dynamodb-types'

import ApiGatewayClient from './aws/aws-gateway-client'

export class DealersContactsApi {
  private readonly client: ApiGatewayClient

  constructor() {
    this.client = new ApiGatewayClient()
  }

  getContactByPhone(phone: string, dealerId?: string): Promise<AxiosResponse<{data: DealersContact[]}>> {
    return this.client.sendRequest({
      endpoint: process.env.VUE_APP_CONTACTS_API,
      method: 'GET',
      path: `/v1/dealers-contacts`,
      queryParams: {
        phone,
        ...(dealerId && {dealerId}),
      },
    })
  }

  getContactById(id: string): Promise<AxiosResponse<{data: DealersContact[]}>> {
    return this.client.sendRequest({
      endpoint: process.env.VUE_APP_CONTACTS_API,
      method: 'GET',
      path: `/v1/dealers-contacts/${id}`,
    })
  }
}

export default new DealersContactsApi()
